import { render, staticRenderFns } from "./LcMedidaFormulario.vue?vue&type=template&id=38c8b096"
import script from "./LcMedidaFormulario.vue?vue&type=script&lang=js"
export * from "./LcMedidaFormulario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports